import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformGroupMember } from './group-members.transformers';
import { GroupMembersCollection } from './group-members.types';

export function groupMembersReducer(
  state: CollectionStateSlice<GroupMembersCollection> = {},
  action: CollectionActions<GroupMembersCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'groupMembers') {
        const { result, ref, order } = action.payload;

        return mergeDocuments<GroupMembersCollection>(
          state,
          transformIntoDocuments(result.members, transformGroupMember),
          order,
          ref,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
